// extracted by mini-css-extract-plugin
export default {"container":"searchPage_container__A4w7g","heading_text_container":"searchPage_heading_text_container__r8tEo"};